document.addEventListener('alpine:init', () => {
  Alpine.data('pmsTable', () => ({
    get shown() {
      return this._shown;
    },
    set shown(value) {
      if (!this._firstTimeShown && history.state?.restoreScrollPosition) {
        if (history.state?.activeRegionName) {
          this.$root.querySelector(`button[data-region-name="${history.state.activeRegionName}"]`)?.click();
        }

        if (history.state?.country) {
          this.$nextTick(() => (this.country = history.state.country));
        }

        this.$nextTick(() => {
          this.pushAndFilter(history.state?.page ?? 1, false, false);
          this.$nextTick(() => this.$refs.results.scrollIntoView());
        });
      }

      this._shown = value;
      this._firstTimeShown = true;
    },
    _shown: false,
    _firstTimeShown: false,

    popular: true,

    rows: [],

    filteredRows: [],

    keywords: history.state?.restoreScrollPosition ? history.state.keywords : '',

    regions: [],

    activeRegionName: 'all',

    country: 'all',

    type: history.state?.restoreScrollPosition ? history.state?.type : 'all',

    page: 1,

    perPage: 10,

    lastPage: 0,

    count: 0,

    pagination: [],

    init() {
      this.popular = !!this.$root.dataset.popular;

      if (this.popular) {
        this.perPage = 9999999;
      }

      this.rows = [
        ...this.$root.querySelectorAll('.pms-table__results-table-rows--static .pms-table__results-table-row'),
      ].map((el) => {
        const regionAnchors = [...el.querySelectorAll('.pms-table__results-table-row-locations--regions a')];
        const countryAnchors = [...el.querySelectorAll('.pms-table__results-table-row-locations--countries a')];

        return {
          id: el.dataset.id,
          name: el.dataset.name,
          image: el.dataset.image,
          link: el.dataset.href,
          types: el.dataset.types.split(',').map(Number),
          regions: el.dataset.regions.split(',').map(Number),
          countries: el.dataset.countries.split(',').map(Number),
          relevance: el.dataset.relevance,
          typeNames: el.querySelector('.pms-table__results-table-row-pm-types')?.innerHTML.trim() ?? '',
          regionAnchors: {
            elements: regionAnchors.map((el) => ({ text: el.textContent, link: el.getAttribute('href') })),
            max: this.calcMaxLocationItems(regionAnchors),
          },
          countryAnchors: {
            elements: countryAnchors.map((el) => ({ text: el.textContent, link: el.getAttribute('href') })),
            max: this.calcMaxLocationItems(countryAnchors),
          },
          regionNames: el.querySelector('.pms-table__results-table-row-locations--regions')?.innerHTML.trim() ?? '',
          countryNames: el.querySelector('.pms-table__results-table-row-locations--countries')?.innerHTML.trim() ?? '',
        };
      });

      this.regions = this.$root.dataset.regions.split(',').map((r) => +r);

      this.filter();
    },

    filter(page, scrollIntoView = false) {
      if (page && !this.shown) {
        // return;
      }

      const results = this.rows.filter((row) => {
        if (row.regions.every((r) => !this.regions.includes(r))) {
          return false;
        }

        if (this.country !== 'all' && !row.countries.includes(this.country)) {
          return false;
        }

        if (this.type !== 'all' && !row.types.includes(this.type)) {
          return false;
        }

        if (this.keywords.trim() && !row.name.toLowerCase().includes(this.keywords.trim().toLowerCase())) {
          return false;
        }

        return true;
      });

      this.count = results.length;
      this.lastPage = Math.ceil(this.count / this.perPage);
      this.page = page ? Math.min(this.lastPage, Math.max(1, page)) : 1;
      this.pagination = [];

      const paginationStart = Math.max(1, this.page - 2);
      const paginationEnd = Math.min(paginationStart + 4, this.lastPage);

      for (let i = paginationStart; i <= paginationEnd; i++) {
        this.pagination.push(i);
      }

      const missing = 5 - this.pagination.length;

      for (let i = 0; i < missing; i++) {
        if (paginationStart - i - 1 >= 1) {
          this.pagination.unshift(paginationStart - i - 1);
        }
      }

      this.filteredRows = results.slice((this.page - 1) * this.perPage, (this.page - 1) * this.perPage + this.perPage);

      if (scrollIntoView) {
        this.$nextTick(() => this.$refs.results.scrollIntoView());
      }
    },

    pushAndFilter(page, restoreScrollPosition = false, scrollIntoView = false) {
      this.push(page, restoreScrollPosition);
      this.filter(page, scrollIntoView);
    },

    push(page, restoreScrollPosition = false) {
      history.pushState(
        {
          activeRegionName: this.activeRegionName,
          country: this.country,
          keywords: this.keywords,
          type: this.type,
          page: page ?? 1,
          restoreScrollPosition,
        },
        null
      );
    },

    changeRegion(e, name, ids) {
      this.activeRegionName = name;
      this.regions = ids;
      this.country = 'all';

      if (e.isTrusted) {
        this.pushAndFilter();
      } else {
        this.filter();
      }
    },

    clearKeywords() {
      this.keywords = '';
      this.pushAndFilter();
    },

    onResultClick() {
      this.push(this.page, true);
    },

    calcMaxLocationItems(elements) {
      let usedCharacters = 0;

      return elements.reduce((max, element) => {
        usedCharacters += element.textContent.length;

        if (usedCharacters <= 100) {
          max++;
        }

        return max;
      }, 0);
    },
  }));
});